import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";
import { Col, Row, Modal, Spin } from "antd";
import {
  ExclamationCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

import TicketList from "../../../components/dashboard/CRM/TicketList";
import AccountTransaction from "../HomeComponent/Act/AccountTransaction";
import AccountTransactionGoing from "../HomeComponent/Act/AccountTransactionGoing";
import AllBankList from "../HomeComponent/Act/AllBankList";
import Widgets from "../HomeCards/Card";

import config from "util/ApiforContext";

const AccountTransactionHome = (props) => {
  const [currencyList, setCurrencyList] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [accountTransactionCount, setAccountTransactionCount] = useState(0);
  const [totalGoing, setTotalGoing] = useState(0);
  const [totalIncoming, setTotalIncoming] = useState(0);
  const [activeKey, setActiveKey] = useState("");
  const [totalCurrencyValue, setTotalCurrencyValue] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isDigitHomePage, setIsDigitHomePage] = useState(false);
  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
    isAdmin: false,
    defaultModuleId: null,
  });

  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const tenantId = localStorage.getItem("tenantId");
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email");
  function boughtEndTimeParatic() {
    window.location.href =
      config.demoUrl +
      "Paketler?vk=" +
      tenantId +
      "&eMail=" +
      email +
      "&t=" +
      token;
  }
  function confirm() {
    Modal.confirm({
      title: "Demo Süreniz Sona Erdi",
      icon: <ClockCircleOutlined style={{ color: "darkred" }} />,
      content:
        "İşletmenize uygun paketi seçerek giriş bilgileriniz değişmeden Finekra'yı kullanmaya devam edebilirsiniz.",
      okText: "Paket Seç",
      onOk: boughtEndTimeParatic,
      keyboard: false,
      cancelButtonProps: { hidden: true },
    });
  }

  useEffect(() => {
    //modüller yüklenmediyse istek atma

    if (permissions.loading) {
      return;
    }

    setTimeout(() => {
      setLoading(false);
    }, 5000);

    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setIsDigitHomePage(response.data.isDigitHomePage);
        }
      }
    );

    RequestHandler.get(`/Tenant/GetById/${tenantId}`).then((res) => {
      var effectiveDate = new Date(res.effectiveDate).getTime();
      var nowDate = Date.now();
      RequestHandler.get(
        `/User/GetById/${localStorage
          .getItem("userId")
          .replace('"', "")
          .replace('"', "")
          .toString()}`
      ).then((resp) => {
        if (nowDate > effectiveDate && res.isDemo) {
          confirm();
        } else if (res.isDemo && !resp.isLogin) {
          setVisibleModal(true);
          RequestHandler.get(
            "/WebSite/DeleteLastLogin?email=" + email + "&changeIsLogin=true"
          ).then((res) => {});
        } else {
          if (permissions.isAdmin) {
            RequestHandler.get(
              "/TransactionBankInfo/IsHaveTransactionBankInfo"
            ).then((resInfo) => {
              if (!resInfo && !res.isDemo) {
                Modal.confirm({
                  title: "Uyarı!",
                  icon: <ExclamationCircleOutlined />,
                  content:
                    "Banka tanımlamalarınız yapılmamıştır. Lütfen tanımlama yapınız.",
                  okText: "Tamam",
                  cancelText: "Vazgeç",
                  onOk() {
                    history.push("/transaction-bank-info");
                  },
                });
              }
            });
          }
        }
      });
    });

    RequestHandler.get(
      "/TenantCurrency?$apply=groupby((Currency,CurrencyId))&$orderby=currencyId"
    ).then((res) => {
      setCurrencyList(res);
      setActiveKey((res[0]?.currencyId ?? 0).toString());

      if (res.length !== 0) {
        RequestHandler.get(
          `/Dashboard/GetHomePageStatistic?currencyId=${
            res[0]?.currencyId ?? 0
          }`
        ).then((res) => {
          setTotalBalance(res.totalBalance);
          setAccountTransactionCount(res.accountTransactionCount);
          setTotalGoing(res.totalGoing);
          setTotalIncoming(res.totalIncoming);
          setLoading(false);
        });
      }
    });

    RequestHandler.get("/Dashboard/GetListForTotal").then((res) => {
      var tenantTotalList = [];
      var total = 0;
      res.map((item) => {
        var model = {
          bankLogo: item.bankLogo,
          totalBalance: item.balance,
          bankName: item.bankName,
          currency: item.tenantList,
        };
        tenantTotalList.push(model);
        total += item.balance;
      });
      var model = {
        bankLogo: "TOPLAM",
        balance: parseFloat(total.toFixed(2)),
      };
      tenantTotalList.push(model);
      setTotalCurrencyValue(parseFloat(total.toFixed(2)));
    });
  }, [
    setCurrencyList,
    setActiveKey,
    setTotalBalance,
    setAccountTransactionCount,
    setTotalGoing,
    setTotalIncoming,
    permissions.loading,
  ]);

  useEffect(() => {
    if (!props.permissions) {
      getUserPermissions();
    } else {
      setPermissions(props.permissions);
    }
  }, [props.permissions]);

  const getUserPermissions = () => {
    setPermissions({
      ...permissions,
      loading: false,
    });
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
      localStorage.setItem("defaultModuleId", response.defaultModuleId);
    });
  };

  const handleOkModal = () => {
    setVisibleModal(false);
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const monthNames = [
    "OCAK",
    "ŞUBAT",
    "MART",
    "NİSAN",
    "MAYIS",
    "HAZİRAN",
    "TEMMUZ",
    "AĞUSTOS",
    "EYLÜL",
    "EKİM",
    "KASIM",
    "ARALIK",
  ];
  const isBigScreen = useMediaQuery({ query: "(min-device-width: 1824px)" });
  const isTablet = useMediaQuery({ query: "(min-width: 768px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1130px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const date = new Date();
  return (
    <>
      {isDesktopOrLaptop ? (
        <Spin spinning={loading}>
          <Row style={{ marginLeft: 2 }}>
            <Col span={24}>
              <div class="ant-row">
                <Widgets
                  icon="home"
                  currency={""}
                  title="TOPLAM BAKİYE"
                  warning={false}
                  totalBalance={
                    !isDigitHomePage ? (
                      <CurrencyFormat
                        value={parseFloat(
                          totalCurrencyValue.toString().split(".")[0]
                        )}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    ) : (
                      <CurrencyFormat
                        value={totalCurrencyValue}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    )
                  }
                />
                <Widgets
                  icon="long-arrow-up"
                  color="green"
                  warning={true}
                  title={`${monthNames[date.getMonth()]} AYI GELEN`}
                  currency={""}
                  totalBalance={
                    !isDigitHomePage ? (
                      <CurrencyFormat
                        value={totalIncoming.toString().split(",")[0]}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    ) : (
                      <CurrencyFormat
                        value={totalIncoming}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    )
                  }
                />
                <Widgets
                  icon="long-arrow-down"
                  warning={true}
                  totalBalance={
                    !isDigitHomePage ? (
                      <CurrencyFormat
                        value={totalGoing.toString().split(",")[0]}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    ) : (
                      <CurrencyFormat
                        value={totalGoing}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"₺"}
                      />
                    )
                  }
                  currency={""}
                  title={`${monthNames[date.getMonth()]} AYI GİDEN`}
                  color="red"
                />
                <Widgets
                  icon="data-entry"
                  warning={false}
                  totalBalance={
                    <CurrencyFormat
                      value={accountTransactionCount}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  }
                  currency={""}
                  title={`${monthNames[date.getMonth()]} AYI HAREKET SAYISI`}
                />
              </div>
            </Col>

            <Col span={12}>
              <TicketList isDigitHomePage={isDigitHomePage} />
            </Col>
            <Col span={12}>
              <AllBankList
                isDigitHomePage={isDigitHomePage}
                forUseHomePage={true}
              />
            </Col>
            <Col span={12} style={{ marginTop: 20, marginBottom: 20 }}>
              <AccountTransaction isDigitHomePage={isDigitHomePage} />
            </Col>
            <Col span={12} style={{ marginTop: 20, marginBottom: 20 }}>
              <AccountTransactionGoing isDigitHomePage={isDigitHomePage} />
            </Col>
          </Row>
        </Spin>
      ) : (
        <Row>
          <Col span={24}>
            <div class="ant-row">
              <Widgets
                icon="home"
                currency={""}
                title="TOPLAM BAKİYE"
                totalBalance={
                  !isDigitHomePage ? (
                    <CurrencyFormat
                      value={parseFloat(
                        totalCurrencyValue.toString().split(".")[0]
                      )}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={"₺"}
                    />
                  ) : (
                    <CurrencyFormat
                      value={totalCurrencyValue}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={"₺"}
                    />
                  )
                }
              />
              <Widgets
                icon="long-arrow-up"
                color="green"
                title={`${monthNames[date.getMonth()]} AYI GELEN`}
                currency={"TRY"}
                totalBalance={
                  !isDigitHomePage ? (
                    <CurrencyFormat
                      value={totalIncoming.toString().split(",")[0]}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  ) : (
                    <CurrencyFormat
                      value={totalIncoming}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  )
                }
              />
              <Widgets
                icon="long-arrow-down"
                totalBalance={
                  !isDigitHomePage ? (
                    <CurrencyFormat
                      value={totalGoing.toString().split(",")[0]}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  ) : (
                    <CurrencyFormat
                      value={totalGoing}
                      displayType={"text"}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      prefix={" "}
                    />
                  )
                }
                currency={"TRY"}
                title={`${monthNames[date.getMonth()]} AYI GİDEN`}
                color="red"
              />
              <Widgets
                icon="data-entry"
                totalBalance={
                  <CurrencyFormat
                    value={accountTransactionCount}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    prefix={" "}
                  />
                }
                currency={""}
                title={`${monthNames[date.getMonth()]} AYI HAREKET SAYISI`}
              />
            </div>
          </Col>
          <Col span={24} style={{ marginLeft: isTablet ? 12 : 0 }}>
            <TicketList isDigitHomePage={isDigitHomePage} />
          </Col>
          <Col
            span={24}
            style={{
              marginBottom: 20,
              maxWidth: isTablet ? "95%" : null,
              marginLeft: isTablet ? 12 : 0,
            }}
          >
            <AllBankList isDigitHomePage={isDigitHomePage} />
          </Col>
          <Col
            span={24}
            style={{
              marginBottom: 20,
              maxWidth: isTablet ? "95%" : "100%",
              marginLeft: isTablet ? 12 : 0,
            }}
          >
            <AccountTransaction isDigitHomePage={isDigitHomePage} />
          </Col>
          <Col
            span={24}
            style={{
              marginBottom: 20,
              maxWidth: isTablet ? "95%" : "100%",
              marginLeft: isTablet ? 12 : 0,
            }}
          >
            <AccountTransactionGoing isDigitHomePage={isDigitHomePage} />
          </Col>
        </Row>
      )}

      <Modal
        visible={visibleModal}
        onOk={handleOkModal}
        cancelButtonProps={{ hidden: true }}
        okText="Deneyelim!"
      >
        <p>Hoşgeldiniz ! Sizleri burada görmekten çok memnunuz.</p>
        <p>
          Sizin için oluşturduğumuz demo ekranlarımızı <strong>5 gün</strong>{" "}
          boyunca inceleyebilirsiniz.
        </p>
        <p>
          Finekra tek ekranda tüm banka hareketlerinizi sunar, hareketlerinizi
          carilerinizle otomatik eşleştirir ve muhasebe programınıza entegre
          olarak aktarım yapabilmenizi sağlar.
        </p>
        <p>-Ayarlar/Hesap Erişimi Ekranından tanım formunu edinin</p>
        <p>-Tanım formunu şubenize iletip bankadan bilgilerinizi alın</p>
        <p>-Kolayca Bilgilerinizi girip kullanmaya başlayın.</p>
        <p>
          Pos Rapor , Toplu Ödeme, DBS gibi diğer ürünlerimiz hakkında bilgi
          almak için buraya tıklayın, size ulaşalım.
        </p>
      </Modal>
    </>
  );
};
export default AccountTransactionHome;
